<div class="flex flex-col z-50 py-6">
    <app-back-home />

    <div class="pb-14 w-full mt-4 flex flex-col gap-4 text-[var(--color-text-strong)]">
        <h3 class="m-0 font-shBreeHeadline text-3xl leading-tight text-[var(--logo-1)]">
            {{ ('seasons.season-overview.title' | translate) || 'Season Overview' }}
        </h3>

        <div class="w-full flex items-center justify-between gap-4">
            <div class="flex w-96 flex-col gap-2">
                <sh-input-text [label]="'seasons.season-overview.search' | translate" [formControl]="searchControl" />
            </div>
            @if (isAdmin()) {
                <sh-button
                    [href]="'/season/create'"
                    color="primary"
                    [ariaLabel]="'seasons.season-overview.buttons.create-new' | translate"
                    icon="plus"
                    iconPosition="left"
                    layout="compact"
                    [label]="'seasons.season-overview.buttons.create-new' | translate"
                />
            }
        </div>

        <div class="relative overflow-x-auto w-full h-full max-h-[60vh]">
            <sh-table>
                <sh-table-row slot="header" labelRows="2">
                    @for (column of columnNames(); track $index) {
                        <sh-table-head unsortable [columns]="column.columns">
                            <span>{{ column.label | translate }}</span>
                        </sh-table-head>
                    }
                </sh-table-row>

                @for (season of filteredSeasons(); track $index) {
                    <sh-table-row>
                        <sh-table-cell columns="4" (click)="handleClickOnSeason(season.id)">
                            <span class="text-[rgb(var(--ui-2))] cursor-pointer my-auto">{{ season.title }}</span>
                        </sh-table-cell>
                        <sh-table-cell columns="4" (click)="handleClickOnSeason(season.id)">
                            <span>
                                {{ season.createdAt | date: 'dd.MM.yyyy' : undefined : 'en' }}
                            </span>
                        </sh-table-cell>
                        <sh-table-cell columns="4" (click)="handleClickOnSeason(season.id)">
                            <span>
                                {{ season.startDate | date: 'dd.MM.yyyy' : undefined : 'en' }} -
                                {{ season.endDate | date: 'dd.MM.yyyy' : undefined : 'en' }}
                            </span>
                        </sh-table-cell>
                        <sh-table-cell columns="3" (click)="handleClickOnSeason(season.id)">
                            <span class="text-[{{ seasonStateTextColor[season.status] }}] cursor-pointer my-auto">{{
                                season.status
                            }}</span>
                        </sh-table-cell>

                        <sh-table-cell columns="4" (click)="handleClickOnSeason(season.id)">
                            <span>{{ season.updatedBy?.firstName }} {{ season.updatedBy?.lastName }}</span>
                        </sh-table-cell>
                        <sh-table-cell columns="4" (click)="handleClickOnSeason(season.id)">
                            <span>
                                {{ season.updatedAt | date: 'dd.MM.yyyy - HH:mm' : undefined : 'en' }}
                            </span>
                        </sh-table-cell>
                        @if (isAdmin()) {
                            <sh-table-cell columns="2">
                                <sh-icon button size="s" icon="more" [id]="'more-trigger-' + season.id" />
                                <sh-popover [target]="'more-trigger-' + season.id" position="bottom" class="p-0">
                                    <sh-list>
                                        <sh-list-item
                                            divider="none"
                                            clickable
                                            icon="edit"
                                            iconSize="xs"
                                            [disabled]="season.status !== seasonStatus.DRAFT"
                                            (click)="season.status === seasonStatus.DRAFT && editSeason(season.id)"
                                            [label]="'seasons.season-overview.table.actions.edit' | translate"
                                        />
                                        <sh-list-item
                                            divider="none"
                                            clickable
                                            icon="checkmark"
                                            iconSize="xs"
                                            [disabled]="season.status !== draftSeasonStatus"
                                            (click)="
                                                season.status === draftSeasonStatus && openSetActiveDialog(season.id)
                                            "
                                            [label]="'seasons.season-overview.table.actions.set-active' | translate"
                                        />
                                        <sh-list-item
                                            divider="none"
                                            clickable
                                            icon="delete"
                                            iconSize="xs"
                                            [disabled]="
                                                season.status === activeSeasonStatus ||
                                                season.status === closedSeasonStatus
                                            "
                                            (click)="
                                                season.status !== activeSeasonStatus &&
                                                    season.status !== closedSeasonStatus &&
                                                    openDeleteDialog(season.id)
                                            "
                                            [label]="'seasons.season-overview.table.actions.delete' | translate"
                                        />
                                    </sh-list>
                                </sh-popover>
                            </sh-table-cell>
                        }
                    </sh-table-row>
                }
            </sh-table>
            @if (isInitalLoading() || isLoading()) {
                <sh-spinner size="m" overlay />
            }
        </div>
    </div>
</div>
